import type { BundleItem } from '../rewards/types';

import type { RankPrizeRange } from './types';

/**
 * The prize a leaderboard position wins: the range of the rank table that holds it. Null for an unranked
 * line or one past X, which wins nothing (contract §9.2: the client finds no range).
 */
export function selectRankPrize(
  rankPrizes: RankPrizeRange[] | undefined,
  position: number | null,
): RankPrizeRange | null {
  if (position === null || !Array.isArray(rankPrizes)) {
    return null;
  }

  return rankPrizes.find((range) => position >= range.from && position <= range.to) ?? null;
}

/**
 * Bundle items as one analytics value: each item's type, in order, comma-separated (`freeSpins,minigameRound`).
 * Empty when there are none, so the column is never null for a coins-only prize.
 */
export function bundleItemsValue(bundleItems: BundleItem[] | null | undefined): string {
  return (bundleItems ?? []).map((item) => item.bundleType).join(',');
}
